export default __webpack_public_path__ + "static/media/wallpaper_bg3.11a6bed7.jpg";